import { Grid, makeStyles, Menu, MenuItem, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { useSelector } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { generateVideoUrl, notifySuccess } from '../utils/Utils';
import Image from '../common/Image';
import { CustomReactPlayer } from '../common/ReactPlayer';
import AddNewStory from './AddNewStory';

const useStyles = makeStyles(() => ({
  descTitle: {
    alignItems: 'flex-start',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textTransform: 'uppercase',
    color: 'rgba(0, 0, 0, 0.4)',
    marginBottom: '8px',
    marginLeft: '40px',
  },
  descText: {
    width: '490px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    marginLeft: '40px',
    color: '#000000',
  },

  headContainer: {
    width: '95%',
    padding: '16px 20px',
    height: '109px',
    background: '#FFFFFF',
    boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.1)',
    marginBottom: '20px',
    marginLeft: '20px',
  },
  headMainText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '22px',
    lineHeight: '27px',
    color: '#000000',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  headSubText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '15px',
    marginTop: '8px',
    color: '#000000',
  },
  headTextContainer: {
    width: '427px',
    height: '77px',
  },
  moreHorIcon: {
    width: '24px',
    height: '24px',
  },
  scrollStyle: {
    height: '65vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  sourceFrame: {
    padding: '0px 12px',
    width: '460px',
    marginBottom: '24px',
    marginLeft: '20px',
    display: 'flex',
    flexDirection: 'row',
  },
  sourceImage: {
    width: '42px',
    height: '42px',
  },
  sourceMainText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '20px',
    color: '#121212',
    opacity: '0.9',
  },
  sourceSubText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    marginTop: '6px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
  imageStyle: {
    width: '460px',
    height: '246px',
    objectFit: 'cover',
    marginBottom: '24px',
    marginLeft: '20px',
  },
  mainDiv: {
    height: '73vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
}));
const RightDailyDoseContent = () => {
  const classes = useStyles();
  const doseDetails = useSelector((state) => state.getDoseDetails.doseDetails);
  const [showEditDailyDose, setShowEditDailyDose] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [decryptedURL, setDecryptedURL] = useState('');

  useEffect(() => {
    if (doseDetails && doseDetails.type === 'VIDEO' && !_isEmpty(doseDetails.av)) {
      const decodedUrl = generateVideoUrl(doseDetails.av);
      setDecryptedURL(decodedUrl);
    }
  }, [doseDetails]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditClick = () => {
    handleClose();
    setShowEditDailyDose(true);
  };

  const handleCloseDailyDosePopup = () => {
    setShowEditDailyDose(false);
  };
  const showDoseCount = () => {
    if (doseDetails !== undefined) {
      if (doseDetails.sources !== undefined) {
        if (doseDetails.sources.length === 1) {
          return doseDetails.sources[0].name;
        }
        if (doseDetails.sources.length > 1) {
          return `${doseDetails.sources[0].name} and ${len} others `;
        }
        return '';
      }
      return '';
    }
    return '';
  };
  const getImageSrc = () => {
    if (doseDetails !== undefined) {
      if (doseDetails.sources !== undefined) {
        if (doseDetails.sources.length > 0) {
          return doseDetails.sources[0].thumbnail;
        }
        return '';
      }
      return '';
    }
    return '';
  };
  let len = '';
  if (doseDetails !== undefined) {
    if (doseDetails.sources !== undefined) {
      len = doseDetails.sources.length - 1;
    }
  }
  return (
    <div className={classes.mainDiv}>
      <Grid container direction="column">
        <Grid item>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className={classes.headContainer}
          >
            <Grid item>
              <Grid container direction="column" className={classes.headTextContainer}>
                <Grid item>
                  <Typography className={classes.headMainText}>{doseDetails?.title}</Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.headSubText}>{doseDetails?.type}</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item className={classes.moreHorIcon}>
              <MoreHorizIcon
                style={{ marginRight: '23px', cursor: 'pointer' }}
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleClick}
              />
            </Grid>
          </Grid>
        </Grid>
        <div>
          <Grid item style={{ marginLeft: '20px', marginBottom: '25px' }}>
            {doseDetails?.type !== 'VIDEO' ? (
              <Image src={doseDetails?.thumbnail} alt="img" className={classes.imageStyle} />
            ) : (
              <CustomReactPlayer width="460px" height="246px" url={decryptedURL} />
            )}
          </Grid>
          <Grid item>
            <Grid className={classes.sourceFrame}>
              <Grid item>
                <Image src={getImageSrc()} alt="Logo" className={classes.sourceImage} />
              </Grid>

              <Grid item>
                <Grid container direction="column" alignContent="flex-start" style={{ marginLeft: '12px' }}>
                  <Grid item>
                    <Typography className={classes.sourceMainText}>{showDoseCount()}</Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.sourceSubText}>
                      {doseDetails?.readingTime}min {doseDetails?.type} from
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Typography className={classes.descTitle}> Description</Typography>
          </Grid>
          <Grid item>
            <div className={classes.descText} dangerouslySetInnerHTML={{ __html: doseDetails?.description }} />
          </Grid>
        </div>
      </Grid>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem style={{ justifyContent: 'left' }} value="Change Level" onClick={handleEditClick}>
          Edit Story
        </MenuItem>
        <MenuItem
          style={{ justifyContent: 'left' }}
          value="Copy Story Scheme Deeplink"
          onClick={() => {
            navigator.clipboard.writeText(doseDetails.schemeDeeplink);
            notifySuccess('Story Scheme Deeplink Copied');
          }}
        >
          Copy Scheme Deeplink
        </MenuItem>
        <MenuItem
          style={{ justifyContent: 'left' }}
          value="Copy Story Universal Deeplink"
          onClick={() => {
            navigator.clipboard.writeText(doseDetails.universalDeeplink);
            notifySuccess('Story Universal Deeplink Copied');
          }}
        >
          Copy Universal Deeplink
        </MenuItem>
      </Menu>
      {showEditDailyDose && <AddNewStory open close={handleCloseDailyDosePopup} add={false} selected="" />}
    </div>
  );
};

export default RightDailyDoseContent;
